import React from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion';
import { useTranslation } from 'react-i18next';

interface FAQItem {
  id: string; // Pour la key et la value de l'AccordionItem
  questionKey: string;
  answerKey: string;
}

interface PricingFAQProps {
  faqItems: FAQItem[];
}

const PricingFAQ: React.FC<PricingFAQProps> = ({ faqItems }) => {
  const { t } = useTranslation();

  return (
    <div className="mt-16 max-w-3xl mx-auto">
      <h2 className="text-3xl font-bold text-center mb-8">{t('pricing.faq_title')}</h2>
      <Accordion type="single" collapsible className="w-full">
        {faqItems.map((item) => (
          <AccordionItem key={item.id} value={item.id}>
            <AccordionTrigger>{t(item.questionKey)}</AccordionTrigger>
            <AccordionContent>
              {t(item.answerKey)}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  );
};

export default PricingFAQ; 